<script lang="ts">
    import { faCalendarAlt, faCaretDown } from '@fortawesome/free-solid-svg-icons'
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'
    dayjs.extend(utc)
    import { createEventDispatcher } from 'svelte'
    import Zinput from './z/zinput.svelte'
    import Zbutton from './z/zbutton.svelte'
    import ZinputGroup from './z/zinput-group.svelte'
    import Zgrid2Popup from './z/zgrid2_popup.svelte'
    import DateSelectPanel from './date-select-panel.svelte'
    const dispatch = createEventDispatcher()

    let className = ''
    export { className as class }
    export let startFrom: Date = null
    export let startTo: Date = null
    export let shortcuts: boolean = true
    export let small: boolean = false
    // "grid": só o painel, sem os campos De/Até e o botão de abrir — usado no popup de um act type "date" do
    // Zgrid2, que já faz o papel do botão. "default": campos De/Até + botão, abrindo o mesmo painel num popup.
    export let skin: 'default' | 'grid' = 'default'

    let isMobile = screen.width <= 900
    let show = false
    let anchor: HTMLElement = null

    let from: Date = startFrom ? new Date(startFrom) : null
    let to: Date = startTo ? window.api.utils.dates.setDateToLastSecondFromDate(new Date(startTo)) : null
    if (!from || !to) {
        const today = window.api.utils.dates.today()
        from = today.from
        to = today.to
    }

    function onApply(event: CustomEvent<{ from: Date; to: Date }>) {
        from = event.detail.from
        to = window.api.utils.dates.setDateToLastSecondFromDate(event.detail.to)
        show = false
        dispatch('change', { from, to })
    }

    // função chamada fora
    export function setDate(_from, _to) {
        _from.setHours(0, 0, 0, 0)
        from = new Date(_from)
        to = window.api.utils.dates.setDateToLastSecondFromDate(_to)
    }
</script>

{#if skin === 'grid'}
    <DateSelectPanel {from} {to} on:apply={onApply} />
{:else}
    <div class="zdate-select {className}">
        <div class="h-screen me-3">
            Período selecionado: {dayjs(from).format('DD/MM/YYYY')} até {dayjs(to).format('DD/MM/YYYY')}
        </div>

        <div class="date-show h-print" bind:this={anchor}>
            {#if !isMobile}
                <ZinputGroup>
                    <Zinput type="date" value={from} label="De" disabled={true}></Zinput>
                    <Zinput type="date" value={to} label="Até" disabled={true}></Zinput>
                    <Zbutton on:click={() => (show = !show)} icon={faCaretDown} title="Escolher período"></Zbutton>
                </ZinputGroup>
            {:else}
                <Zbutton on:click={() => (show = !show)} icon={faCalendarAlt} title="Escolher período"></Zbutton>
            {/if}
        </div>

        {#if show}
            <div class="h-print">
                <Zgrid2Popup {anchor} width={300} on:close={() => (show = false)}>
                    <DateSelectPanel {from} {to} on:apply={onApply} />
                </Zgrid2Popup>
            </div>
        {/if}
    </div>
{/if}
